import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


class EventsFinder extends Component {

    constructor(props){
        super(props)
        this.getErrorMessagesStr = this.getErrorMessagesStr.bind(this)
    }

    getErrorMessagesStr(errorMessages){
        if (errorMessages.invalidId){
            return 'El ID del evento es invalido'
        }
        if (errorMessages.invalidClientId){
            return 'El ID del cliente es invalido'
        }
        if (errorMessages.invalidName){
            return 'El nombre del fallecido es invalido'
        }
        if (errorMessages.invalidEventDate){
            return 'La fecha del evento es invalida'
        }
        return ''
    }

    render(){
        const {
            eventData,
            availableRooms,
            onSearchClick,
            onEventIdChange,
            onClientIdChange,
            onNameChange,
            onRoomChange,
            onDateChange,
            eventsFound
        } = this.props
        const {getErrorMessagesStr} = this
        const eventDataErrorsStr = getErrorMessagesStr(eventData.errorMessages)
        return(
            <div>
                <div className="line-header-text">Buscar eventos</div>
                <div className="events-finder-search">
                    <table>
                            <tr>
                                <th className="table-left">ID del evento</th>
                                <th>
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={eventData.id}
                                        placeholder="**Todos"
                                        onChange={onEventIdChange}
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">ID del cliente</th>
                                <th >
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={eventData.client_id}
                                        onChange={onClientIdChange}
                                        placeholder="**Todos"
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Nombre del fallecido</th>
                                <th >
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={eventData.name}
                                        onChange={onNameChange}
                                        placeholder="**Todos"
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Sala</th>
                                <th >
                                    <select
                                        className="select-css select-css-small"
                                        value={eventData.room_id}
                                        disabled={false}
                                        onChange={onRoomChange}
                                    >
                                    {
                                        Object.keys(availableRooms).map(key => {
                                            return (
                                                <option value={key} key={key}>{availableRooms[key].name}</option>
                                            )
                                        })
                                    }
                                    </select>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Fecha</th>
                                <th className="table-left">
                                <div>
                                    <DatePicker
                                    selected={eventData.eventDate}
                                    onChange={date => onDateChange(date)}
                                    />
                                </div>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div className="search-button-large-margin">
                        <input
                            className="button-add-reserve"
                            type="button"
                            value="buscar"
                            onClick={onSearchClick}
                            disabled={eventDataErrorsStr.length > 0}/>
                    </div>
                    <div>
                        {
                            eventsFound ?
                            <div className="text-success">Resultado de la busqueda listo</div> :
                            <div className="error-message">{eventDataErrorsStr}</div>
                        }
                    </div>
            </div>
        )
    }
}

export default EventsFinder
